<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-icon v-if="plain" :color="color" :title="tooltip">{{ icon }}</v-icon>
        <v-btn v-else icon :color="color" :loading="loading" :title="tooltip">
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </span>
    </template>
    <v-list dense>
      <v-list-item v-for="(st, i) in states" :key="i" @click="$emit('changed', st.value)">
        <v-list-item-icon>
          <v-icon :color="getColor(st.value)">{{ getIcon(st.value) }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ st.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { getStateColor, getStateIcon } from "@/components/dashboard/bookings/bookingFormatters";

export default {
  name: "BookingStateMenu",
  props: {
    state: { type: String, default: null },
    states: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    plain: { type: Boolean, default: false },
  },
  computed: {
    color() { return getStateColor(this.state); },
    icon() { return getStateIcon(this.state); },
    tooltip() { return this.getStateTooltip(this.state); },
  },
  methods: {
    getColor: getStateColor,
    getIcon: getStateIcon,
    getStateTooltip(state) {
      const t = {
        "Новая": this.$t("bookings_states.new"),
        "В обработке": this.$t("bookings_states.in_work"),
        "Отказ клиента": this.$t("bookings_states.decline"),
        "Нет машин": this.$t("bookings_states.no_cars"),
        "Недозвон": this.$t("bookings_states.abandoned"),
        "Ожидает ответа клиента": this.$t("bookings_states.wait_answer"),
        "Ожидает оплаты": this.$t("bookings_states.wait_pay"),
        "Активная": this.$t("bookings_states.active"),
        "Отмена": this.$t("bookings_states.cancel"),
        "Отъездила": this.$t("bookings_states.rided"),
        "Вернуть залог": this.$t("bookings_states.return_deposit"),
        "Подтверждена": this.$t("bookings_states.accepted"),
        "Не подтверждена": this.$t("bookings_states.not_accepted"),
        "Другое": this.$t("bookings_states.other"),
      };
      return t[state] || state;
    },
  },
};
</script>
